import styled from '@mui/material/styles/styled'

export const Content = styled('div', {
  name: 'Content',
})(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  flexFlow: 'row nowrap',
  [theme.breakpoints.down('lg')]: {
    flexFlow: 'column nowrap',
  },
}))
